export enum ItemKind {
    Unknown = 'U',
    Fee = 'F',

    Award = 'A',
    LabSimCourse = 'L',
    LabSimExam = 'C',
    EventRegistration = 'R',
    SwagMerchandise = 'S',
}

export enum ItemMedium {
    CD = 'C',
    DVD = 'D',
    BackupDVD = 'B',
    Online = 'O',
    Paper = 'P',
    Box = 'S',
    None = 'X'
}

export let ItemVendorCodes = {
    TestOut: "TO",
    Microsoft: "MS",
    CompTIA: "CT",
    Cisco: "CS"
}

export let ItemGroupCodes = {
    GroupLicense: "SL"
}

export enum FeeTypes {
    ServiceFee = "SERVICE",
    FreightFee = "FREIGHT",
    WireTransferFee = "WIRETRANSFER",
    RestockingFee = "DEACTIVATION",
    RestockingLateFee = "NONCOMPLIANCEFEE"
}

export class ItemNumber implements IItemNumber {
    value: string;

    constructor(value: string) {
        this.value = value;
    }

    toString() {
        return this.value;
    }

    toJSON(): string {
        return this.value;
    }

    //Being Calculated Properties

    get vendorCode() {
        return (this.value == null || this.isFeeItemNumber || this.value.length < 2) ? null : this.value.substr(0, 2);
    }

    get groupCode() {
        return (this.value == null || this.isFeeItemNumber || this.value.length < 4) ? null : this.value.substr(2, 2);
    }

    get groupVersion(): number {
        return (this.value == null || this.isFeeItemNumber || this.value.length < 6) ? -1 : parseInt(this.value.substr(4, 2));
    }

    get medium(): ItemMedium {
        return (this.value == null || this.isFeeItemNumber || this.value.length < 7) ? ItemMedium.None : this.value[6] as ItemMedium;
    }

    get kind(): ItemKind {
        return this.isFeeItemNumber
            ? ItemKind.Fee
            : ((this.value == null || this.value.length < 8) ? ItemKind.Unknown : this.value[7] as ItemKind);
    }

    get code() {
        return (this.value == null || this.isFeeItemNumber || this.value.length < 10) ? null : this.value.substr(8, 2);
    }

    get version(): number {
        return (this.value == null || this.isFeeItemNumber || this.value.length < 12) ? -1 : parseInt(this.value.substr(10, 2));
    }

    get cultureCode() {
        return (this.value == null || this.isFeeItemNumber || this.value.length < 16) ? null : this.value.substr(12, 14);
    }

    get isFeeItemNumber(): boolean {
        return FeeTypes.ServiceFee.localeCompare(this.value) === 0 ||
            FeeTypes.FreightFee.localeCompare(this.value) === 0 ||
            FeeTypes.WireTransferFee.localeCompare(this.value) === 0 ||
            FeeTypes.RestockingFee.localeCompare(this.value) === 0 ||
            FeeTypes.RestockingLateFee.localeCompare(this.value) === 0;
    }

    //End Calculated Properties
}

export interface IItemNumber {
    value: string;
}